
  
 <div class="form-group" [formGroup]="form" >
  <div class="payment-input controls {{field.className}}" [ngClass]="validationClass ? validationClass : ''" >
        <input class="floatLabel form-control" #dynamicInputElement [attr.type]="field.type" [id]="field.id" [value]="field.value" [name]="field.name" [formControlName]="field.name" (keyup)="onKeyUp($event)"  (input)="getValidationClass()" (keydown)="onKeyDown($event)" (blur)="checkFieldValidation(true)">
        <label [for]="field.id">{{field.label | translate}}</label>
  </div>
 </div>
